import { isMobile } from "../../aliud/ts/functions";

export function aliudNavigation() {

	var navbar = document.querySelector(".ff-navbar-nav");

	if (!navbar) { return };

	var entryItems = navbar.querySelectorAll(".entry-item");
	var wrappers = navbar.querySelectorAll(".nav-wrapper");
	var mobileHeaders = navbar.querySelectorAll(".mobile-header");
	var btnNavBack = document.querySelector(".btn-nav-back");
	var body = document.querySelector("body");

	entryItems.forEach(function (entryItem) {
		var thisParent = entryItem.parentElement || entryItem;

		entryItem.addEventListener('click', function (event) {
			event.preventDefault();
			var eventTarget = event.target as Element;
			addAndRemoveCss(thisParent, eventTarget);
		});

	});
	var searchButton = document.querySelector("#simpleSuchButton a");

	document.querySelector('.al-navbar-default')?.addEventListener('mouseup', function (e) {
		removeClasses();
	});

	searchButton?.addEventListener('click', function (event) {
		event.preventDefault();
		removeClasses();
	})

	addEventListener('resize', function () {
		removeClasses();
	});

	btnNavBack?.addEventListener("click", function (e) {
		e.preventDefault();
		if ( isMobile() ) { 
			wrappers.forEach(function (element) {
				element.classList.remove("selected");
			})
			mobileHeaders.forEach(function (element) {
				element.classList.remove("selected");
			})
		}
	});

	function addAndRemoveCss(target: Element, element: Element) {
		var navWrapper = target.querySelector('.nav-wrapper');
		removeClasses();
		if (navWrapper) {
			addClasses(navWrapper, element);
		}
	}
	function removeClasses() {
		wrappers.forEach(function(element) {
			element.classList.remove("selected");
		})
		mobileHeaders.forEach(function (element) {
			element.classList.remove("selected");
		})
		entryItems.forEach(function (element) {
			element.classList.remove("clicked");
		})
		body!.classList.remove('navbar-open');
	}
	function addClasses(navWrapper: Element, current: Element) {
		navWrapper.classList.add("selected");
		current.classList.add("clicked");
		body!.classList.add('navbar-open');
	};

};

export function stickyMenu() {

	var element = document.querySelector(".ff-navbar");
	var searchContainer = document.querySelector(".suchformularContentContainer");
	let position = window.scrollY;
	let mql = window.matchMedia("(min-width: 768px)");
	var isLocked = false;
	document.addEventListener('scroll', function(event) {
        documentScrollHandler();
    });
	documentScrollHandler();

	function documentScrollHandler() {
		if (!mql.matches)
            return;
			
		var scrollY = window.scrollY;

		searchContainer = document.querySelector(".suchformularContentContainer");
		if (!searchContainer)
			return;

		isLocked = searchContainer!.classList.contains("visible");
		if (!isLocked)
		{ 
			if (scrollY > 120) {
				element!.classList.add("menu-sticky");
				if (scrollY > position) {
					element!.classList.add('down');
					element!.classList.remove('up');
				} else {
					element!.classList.add('up');
					element!.classList.remove('down');
				}

				position = scrollY;

			}
			else {
				element!.classList.remove("menu-sticky");
				element!.classList.remove('up');
				element!.classList.remove('down');
			}
		}
	}
};

export function mobileNav() {

	//		if ( !isMobile() ) { return; }

	var toggler = document.querySelector(".ff-toggler");
	if (!toggler) return;

	var targetContent = document.querySelector(".mobile-wrapper");
	var wrappers = document.querySelectorAll(".ff-navbar-nav .nav-wrapper");
	var collapsed = true;

	toggler.addEventListener('click', function (event) {
		event.preventDefault();
		if (collapsed) {
			navManager(true);
		}
		else {
			navManager(false);
		}
	});

	window.addEventListener('resize', function () {
		navManager(false);
	});

	var navManager = function (show: boolean) {

		if (show) {
			collapsed = false;
			toggler?.classList.remove('collapsed');
			targetContent?.classList.remove('collapsed');
		}
		else {
			collapsed = true;
			toggler?.classList.add('collapsed');
			targetContent?.classList.add('collapsed');
			wrappers.forEach(function (item) {
				item.classList.remove('selected');
			})
		}


	}

};